"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _default = function _default() {
  return _react.default.createElement(_UIErrorMessage.default, {
    className: "playbooks-modal-error-state"
  }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "playbooksModal.error.somethingIsWrongMessage"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: "playbooksModal.error.contactSupport"
  })));
};

exports.default = _default;
module.exports = exports.default;